export default __webpack_public_path__ + "media/images/react_icons/paper_write_light_landlord-f795fd75db37035d05799f41e83594c2.svg";